module.exports = __webpack_public_path__ + "static/media/decodificador_b.71f3cec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/decodificador_b.png
// module id = 1165
// module chunks = 0